<template>
  <section class="flex horizontal items-center justify-center my-8">
    <div>
      <button
        class="text-primary text-xl flex justify-center items-center mb-4"
        v-on:click="refresh"
      >
        <h4 class="mr-2">&#8370;</h4>
        <h1 class="mr-3">{{ animatedBalance | currency }}</h1>
        <div class="refresh-btn">
          <Refresh class="fill-current w-full h-full" v-bind:class="{rotate: loading}"/>
          <div class="rotate hidden">prevent purgecss remove this class</div>
        </div>
      </button>
      <h5 class="header">INICIAL: &#8370; {{ initial_balance | currency }}</h5>
    </div>
  </section>
</template>

<script>
import Refresh from "@/icons/refresh.svg";
import { TweenLite } from "gsap";
export default {
  name: "Balance",
  props: {
    actual_balance: {
      type: [Number, String]
    },
    initial_balance: {
      type: [Number, String]
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      tweenedBalance: 0
    };
  },
  components: {
    Refresh
  },
  computed: {
    animatedBalance: function() {
      return this.tweenedBalance.toFixed(0);
    }
  },
  methods: {
    refresh: function() {
      this.$store.dispatch({
        type: "forceFetchAccount",
        data: { id: this.$route.params.id, sub_id: this.$route.params.sub_id }
      });
    }
  },
  watch: {
    actual_balance: function(newValue) {
      TweenLite.to(this.$data, 0.5, { tweenedBalance: newValue });
    }
  },
  mounted() {
    TweenLite.to(this.$data, 0.5, { tweenedBalance: this.actual_balance });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  transition: all 0.2s ease-in;
}
</style>
